import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities'
import { attributesAnalytics } from '../../js/modules/component'

export const TuileAiguillage2 = ({ image, title, CTA: { analytics, URL, label } }) => {
   return (
      <a href={URL} class="tuile-aiguillage-2 lien-composite" {...attributesAnalytics(analytics)}>
         <h3 class="h4 title m-0 p-0">
            <span dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
         </h3>
         <img src={image} alt="" class="decorative" />
         <span href={URL} class="btn btn-primary">
            {label}
         </span>
      </a>
   )
}
